/* Actions */
export const GET_REQUEST = "GET_REQUEST";

/* Mutations */
export const GET_SUCCESS = "GET_SUCCESS";
export const GET_ERROR = "GET_ERROR";
export const RESET = "RESET";
